import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdRateGrid() {
  return useQuery({
    queryKey: ['rd-rate-grid'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getRateGrid();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar a grade de taxas do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
